export default __webpack_public_path__ + "static/media/quiz.45e07181.jpg";